import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { Button } from './ui/button';
import { Quote, Star, Home } from 'lucide-react';
import { mockSuccessStories } from '../mock/mock';

const SuccessStories = () => {
  const navigate = useNavigate();
  
  return (
    <div className="py-16 bg-gradient-to-br from-slate-50 via-blue-50 to-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Success Stories from Mysore
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real people, real results. See how our retirement planning has helped families in Mysore secure their financial future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockSuccessStories.map((story, index) => (
            <Card key={index} className="shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-0">
              <CardHeader className="text-center pb-4">
                <div className="flex justify-center mb-4">
                  <Avatar className="w-20 h-20 border-4 border-blue-200">
                    <AvatarFallback className="text-2xl font-bold bg-gradient-to-br from-blue-800 to-green-700 text-white">
                      {story.initials}
                    </AvatarFallback>
                  </Avatar>
                </div>
                <CardTitle className="text-xl font-bold text-gray-800">
                  {story.name}
                </CardTitle>
                <p className="text-sm text-gray-500">{story.profession} • Age {story.age}</p>
              </CardHeader>
              <CardContent className="px-6 pb-6">
                <div className="flex justify-center mb-4">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
                
                <div className="relative">
                  <Quote className="absolute -top-2 -left-2 w-8 h-8 text-blue-300" />
                  <p className="text-gray-700 italic pl-6 mb-4 leading-relaxed">
                    "{story.testimonial}"
                  </p>
                </div>

                <div className="bg-gradient-to-r from-green-100 to-blue-100 rounded-lg p-4 mt-4">
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="font-semibold text-gray-700">SIP Amount:</p>
                      <p className="text-green-600 font-bold">₹{story.sipAmount.toLocaleString('en-IN')}</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700">Target Corpus:</p>
                      <p className="text-blue-600 font-bold">₹{story.targetCorpus}L</p>
                    </div>
                    <div className="col-span-2">
                      <p className="font-semibold text-gray-700">Retirement Goal:</p>
                      <p className="text-purple-600 font-bold">{story.retirementGoal}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 italic mb-6">
            * All individuals have provided public consent for sharing their success stories
          </p>
          
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="flex items-center gap-2 border-2 border-blue-800 text-blue-800 hover:bg-blue-800 hover:text-white transition-colors mx-auto mb-8"
          >
            <Home className="w-5 h-5" />
            Back to Home
          </Button>

          {/* SEBI Compliance Disclaimer */}
          <div className="pt-8 border-t border-gray-300">
            <p className="text-lg font-bold text-red-600">
              Mutual Fund investments are subject to market risks. Read all scheme-related documents carefully before investing
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;